<template>
  <q-page padding>
    <div class="row q-gutter-sm">
      <div class="col-xs-12 col-sm-8">
        <p class="text-h6 text-weight-bold text-brand-5 texto-titulo">
          Gestão das Categorias de Produtos
        </p>
      </div>
    </div>
    <div
      class="row col-12 q-gutter-sm text-brand-5 text-weight-bold q-mt-md container-inputs no-wrap"
    >
      <div class="col-md-3 col-xs-3 col-sm-3">
        <div class="q-ml-sm texto-titulo-input">Código</div>
        <q-input mask="NNNNNN" v-model="dados.codigo" dense outlined />
      </div>
      <div class="col-md-3 col-xs-5 col-sm-5">
        <div class="q-ml-sm texto-titulo-input">Descrição</div>
        <q-input v-model="dados.descricao" dense outlined />
      </div>
      <div>
        <p></p>
        <q-btn
          class="q-mt-sm btn"
          color="positive"
          label="Criar Categoria"
          no-caps
          icon="add"
          @click="criarCategoria()"
        />
      </div>
    </div>
    <div class="q-mt-xl col-12 container-table">
      <q-table
        :columns="columns"
        :rows="listaCategorias"
        class="q-mt-lg tabela-tamanho-fixo"
        color="primary"
        dense
        row-key="id"
        table-header-class="bg-accent text-weight-bold"
        hide-pagination
        :grid="$q.screen.lt.sm"
        hide-bottom
        :loading="loading"
        flat
      >
        <template v-slot:item="props">
          <div class="col-xs-12 col-sm-6 col-md-4 q-mb-md">
            <div class="row card text-grid-table text-brand-5 q-pa-sm">
              <div class="row col-12 items-center justify-between">
                <span class="col-9 q-ml-sm"
                  ><strong>Codigo: </strong>{{ props.row.code }}</span
                >
                <span class="col-9 q-ml-sm"
                  ><strong>Descrição: </strong>{{ props.row.description }}</span
                >
                <div></div>
              </div>
            </div>
          </div>
        </template>
        <template v-slot:body-cell-codigo="props">
          <q-td class="text-brand-5 text-weight-bold" :props="props">
            {{ props.row.code }}
          </q-td>
        </template>
        <template v-slot:body-cell-descricao="props">
          <q-td class="text-brand-5 text-weight-bold" :props="props">
            {{ props.row.description }}
          </q-td>
        </template>
        <template v-slot:body-cell-remover="props">
          <q-td class="text-brand-5 text-weight-bold" :props="props">
            <q-btn
              color="negative"
              icon="delete"
              flat
              no-caps
              push
              @click="abrirModalRemover(props.row.id)"
            />
          </q-td>
        </template>
      </q-table>
      <div class="row justify-start q-mt-md">
        <q-pagination
          :disable="disable"
          v-model="pagination.page"
          color="brand-5"
          active-color="secondary"
          active-text-color="white"
          :max="pagesNumber"
          :max-pages="5"
          :boundary-numbers="false"
          :direction-links="true"
          size="sm"
        />
      </div>
    </div>

    <DialogConfirmDesign
      :mensagem="modalRemover.mensagem"
      :exibir="modalRemover.exibir"
      :titulo="modalRemover.titulo"
      @resultado="confirmarRemover"
    />
  </q-page>
</template>

<script>
import { onMounted, ref, computed, watch } from "vue";
import { useQuasar } from "quasar";
import { useStore } from "vuex";
import DialogConfirmDesign from "../../../components/DialogConfirmDesign.vue";

export default {
  components: {
    DialogConfirmDesign,
  },
  setup() {
    const columns = [
      {
        name: "codigo",
        label: "Código",
        align: "left",
        field: "code",
      },
      {
        name: "descricao",
        label: "Descrição",
        align: "left",
        field: "description",
      },
      {
        name: "remover",
        label: "Remover",
        align: "left",
        field: "remover",
      },
    ];

    const store = useStore();
    const quasar = useQuasar();

    const listaCategorias = ref([]);
    let disable = ref(false);
    let loading = ref(false);
    const dados = ref({
      codigo: "",
      descricao: "",
    });
    const pagination = ref({
      sortBy: "desc",
      descending: false,
      page: 1,
      rowsPerPage: 6,
      rowsNumber: 6,
    });

    const modalRemover = ref({
      exibir: false,
      mensagem: "",
      titulo: "Confirmar Remoção",
      categoriaId: null,
    });

    const listarCategorias = async (page = 1, rowsPerPage = 6) => {
      loading.value = true;
      disable.value = true;
      try {
        let response = await store.dispatch("produtos/listarCategorias", {
          per_page: rowsPerPage,
          page: page,
        });
        listaCategorias.value = response.data.results.data;
        pagination.value.rowsPerPage = response.data.results.per_page;
        pagination.value.page = response.data.results.current_page;
        pagination.value.rowsNumber = response.data.results.total;
        loading.value = false;
        disable.value = false;
      } catch (error) {
        console.log(error);
        loading.value = false;
      }
    };

    const criarCategoria = async () => {
      if (dados.value.codigo == "" || dados.value.descricao == "") {
        quasar.notify({
          message: "Preencha todos os campos",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        return;
      }
      try {
        await store.dispatch("produtos/adicionarCategoria", {
          code: dados.value.codigo,
          description: dados.value.descricao,
        });
        listarCategorias();
        reset();
        quasar.notify({
          message: "Categoria criada com sucesso",
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      } catch (error) {
        console.log(error);
        quasar.notify({
          message: "Erro ao criar categoria",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    const abrirModalRemover = (id) => {
      modalRemover.value.categoriaId = id;
      modalRemover.value.mensagem = "Tem certeza que deseja remover essa Categoria?";
      modalRemover.value.exibir = true;
    };

    const confirmarRemover = async (confirmado) => {
      modalRemover.value.exibir = false;

      if (!confirmado) {
        modalRemover.value.categoriaId = null;
        return;
      }

      const id = modalRemover.value.categoriaId;

      try {
        await store.dispatch("produtos/removerCategoria", {
          id: id,
        });
        listarCategorias();

        quasar.notify({
          message: "Categoria removida com sucesso",
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      } catch (error) {
        console.log(error);
        quasar.notify({
          message:
            "Não é possível excluir a categoria porque ela está vinculada a pelo menos um produto!",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }

      modalRemover.value.categoriaId = null;
    };

    const paginarTabela = async () => {
      listarCategorias(pagination.value.page, pagination.value.rowsPerPage);
    };

    const reset = () => {
      dados.value = {
        codigo: "",
        descricao: "",
      };
    };

    watch(
      () => pagination.value.page,
      () => {
        listarCategorias(pagination.value.page, pagination.value.rowsPerPage);
      }
    );

    onMounted(listarCategorias);
    return {
      columns,
      listarCategorias,
      listaCategorias,
      pagination,
      pagesNumber: computed(() =>
        Math.ceil(pagination.value.rowsNumber / pagination.value.rowsPerPage)
      ),
      paginarTabela,
      criarCategoria,
      dados,
      reset,
      loading,
      disable,
      abrirModalRemover,
      confirmarRemover,
      modalRemover,
    };
  },
};
</script>
<style scoped>
@media (max-width: 600px) {
  .texto-titulo {
    font-size: 14px;
    margin-top: 10px;
  }
  .texto-titulo-input {
    font-size: 12px;
    margin: 0px;
  }
  .container-inputs {
    margin: 8px 0px 0px 0px;
    padding: 0px;
  }
  .btn {
    font-size: 10px;
    height: 30px;
    margin: 4px 0px 0px 0px;
  }
  .card {
    border: 1px solid #707070;
    border-radius: 5px;
  }
  .text-grid-table {
    font-size: 12px;
  }
  .container-table {
    margin-left: 4px;
    margin-right: 4px;
  }
}
@media (max-width: 393px) {
  .btn {
    font-size: 9px;
    height: 30px;
    margin: 4px 0px 0px 0px;
  }
}
</style>
